<template>
  <vs-card class="generated_gradebook_preview">
       <div class="" :class="{show: savePreview}">
         <h5 class="text-center" style="padding:10px;color:#626262">Gradebook Preview</h5>
         <vs-divider/>
         <div v-if="gradebookGenerated">
                <div class="sm:flex flex-wrap justify-between">
                    <div>
                        <div class="logo_wrapper">
                            <h3 style="color: rgba(var(--vs-primary), 1);" class="mb-2">{{school_name}}</h3>
                        </div>
                        <p>{{school_address}}</p>
                    </div>
                    <div>
                        <h4 class="mb-2">Report Card</h4>
                        <div>
                            <label>Date: </label>
                            <strong>{{report_date | dateFormatLocalization}}</strong>
                        </div>
                    </div>
                </div>
                <vs-divider />

                <div class="sm:flex flex-wrap justify-between">
                    <div class="mb-4 sm:mb-0">
                        <h5 class="mb-2">Student Details:</h5>
                         <div>
                            <label>Name: </label>
                            <span> {{student_name}}</span>
                        </div>
                        <div>
                            <label>Instructor: </label>
                            <span> {{teacher_name}}</span>
                        </div>
                        <div>
                            <label>Course: </label>
                            <span> {{course_name}}</span>
                        </div>
                    </div>
                    <div>
                        <h5 class="mb-2">Report Details:</h5>                        
                        <div>
                            <label>Marks (in %): </label>
                            <span>{{total_mark_obtained}}</span>
                        </div>
                        <div>
                            <label>Grade: </label>
                            <span>{{final_result_grade}}</span>
                        </div>
                    </div>
                </div>

                <div class="cstm_vuexy_table my-4">
                    <table class="w-full marksheet-table" style="border-collapse: collapse">
                        <tbody>
                            <tr>
                                <th>Area</th>
                                <th>Type</th>
                                <th>Marks</th>
                            </tr>

                            <tr v-for="(details, index) in attendance_details" :key="index">
                                <td><b>Attendance</b></td>
                                <td>-</td>
                                <td>{{details[Object.keys(details)[0]].marks_obtained}}</td>
                            </tr>

                            <tr v-for="(details, index) in exam_details[0]" :key="index">
                                <td><b>Exam</b></td>
                                <td>{{details.assignment_title}}</td>
                                <td>{{Number(details.marks_obtained)}}</td>
                            </tr>

                           <tr v-for="(details, index) in homework_details[0]" :key="index">
                                <td><b>Homework</b></td>
                                <td>{{details.assignment_title}}</td>
                                <td>{{Number(details.marks_obtained)}}</td>
                            </tr>
                        </tbody>
                        <tfoot>
                            <tr>
                                <td>
                                    <b style="margin-right:10px">Result : <span class="passed"> {{final_result}} </span></b>
                                    <b>Grade : <span class="passed"> {{final_result_grade}} </span></b>
                                </td>
                                <td><b>Total:</b></td>
                                <td>{{total_mark_obtained}}</td>
                            </tr>
                        </tfoot>
                    </table>

                    <vs-divider />

                    <h5 class="mb-2">Report:</h5>
                    <!-- <pre>{{report_details}}</pre> -->
                    <div v-for="(reportItem, index) in report_details" :key="index">
                        <b>{{reportItem.question_title}}</b>
                        <p>{{reportItem.question_answer}}</p>
                    </div>

                    <vs-divider />

                    <div class="">
                        <h5>Teacher Feedback</h5>
                        <p>{{teacher_feedback}}</p>
                    </div>
                    <!-- <p><b>N.B:</b> Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p> -->
                </div>
           </div>
                <div class="text-center pb-4">
                    <vs-button class="mx-1" @click="generateGradebook()" v-if="!gradebookGenerated">Generate Gradebook</vs-button>

                </div>
            </div>
  </vs-card>
</template>
<script>

import { studentGradebook } from '@/api/grade'
export default {
  name: 'GenerateGradebook',
  components: {
  },
  props: {
    course_data:{
      required: true
    },
    client_user_id:{
      required: true
    }
  },
  data () {
    return {
      gradebookGenerated:false,
      submit_type:null,
      canEdit: false,
      report_date:'',
      teacher_name:'',
      school_name:'',
      course_name:'',
      student_name:'',
      school_address:'',
      total_mark_obtained:'',
      teacher_feedback:'',
      attendance_details:[],
      homework_details:[],
      exam_details:[],
      report_details:[],
      gradebook_data:null,
      final_result_grade:null,
      final_result:null,
      feedback: false,
      savePreview: false
    }
  },
  mounted () {
    
  },
  
  methods : {
    generateGradebook () {
      const client_user_id = this.client_user_id
      const course_id =  this.course_data.course_id
      const payload = {
        client_user_id,
        course_id
      }
      this.studentGradebook(payload)
    },
    async studentGradebook (payload) {
      try {
        this.$vs.loading()
        this.attendance_details = []
        this.homework_details = []
        this.exam_details = []
        this.report_details = []
        const customer_id = this.$store.getters.customerId
        const {data} = await studentGradebook(customer_id, payload)
        this.gradebook_data = data.data
        this.submit_type = this.gradebook_data.grade_info.grade_book_detail.submit_type
        this.final_result = this.gradebook_data.grade_info.grade_book_detail.result
        this.final_result_grade = this.gradebook_data.grade_info.grade_book_detail.grade
        this.teacher_feedback = this.gradebook_data.grade_info.grade_book_detail.teacher_feedback
        this.total_mark_obtained = Number(this.gradebook_data.grade_info.grade_book_detail.total_mark_obtained)
        this.course_name = this.gradebook_data.grade_info.course_name.name
        this.teacher_name = this.gradebook_data.grade_info.teacher_name
        this.school_name = this.gradebook_data.grade_info.school_name.brand_company_name
        this.student_name = `${this.gradebook_data.grade_info.client_user_name.first_name  } ${   this.gradebook_data.grade_info.client_user_name.last_name}` 
        this.report_date = this.gradebook_data.grade_info.grade_book_detail.created_at
        
        const {address1, address2, state, city, zip} = this.gradebook_data.grade_info.school_name.platform_customer_branches
        this.school_address = `${address1}, ${address2}, ${state}, ${city}, ${zip}`
        
        this.report_details = this.gradebook_data.grade_components.reports.filter((x) => {
          return x.question_answer !== null
        })
      
        if (this.gradebook_data.grade_components.attendance) {
          Object.values(this.gradebook_data.grade_components.attendance).forEach((val, key) => {
            this.attendance_details.push(val)
          })
        }

        if (this.gradebook_data.grade_components.Homework) {
          Object.values(this.gradebook_data.grade_components.Homework).forEach((val, key) => {
            this.homework_details.push(val)
          })
        }

        if (this.gradebook_data.grade_components.Exam) {
          Object.values(this.gradebook_data.grade_components.Exam).forEach((val, key) => {
            this.exam_details.push(val)
          })
        }

        this.gradebookGenerated = true
        this.$vs.notify({
          title: 'Success',
          text: 'Gradebook Generated',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success',
          time: 3000
        })
      } catch (e) {
        console.log(e)
      } finally {
        this.$vs.loading.close()
      }
    }
  }
}
</script>


<style>
.passed {
    color: #28c76f;
    text-transform: uppercase;
}
.fail {
    color: #ff0000;
    text-transform: uppercase;
}
</style>

<style scoped>
.finall_result{
    display:inline-block;
    margin-right:20px;
    max-width:145px !important;
    width:145px;
    font-size: 12.5px;
}
.finall_grade{

}

.generated_gradebook_preview {
  width: 90%;
  margin: auto;
}
</style>